import { transport } from 'config/transport';

export function callApiExportMamNonMonthlyReport(congDoanId, yearMonth, pdf = false) {
    return transport.get(`/mamnon/${congDoanId}/thuchi/exportReport`, { params: { yearMonth, pdf }, responseType: 'blob' });
}
